import React, { useState } from "react";
import "./App.css";
import useReveal from "./hooks/useReveal";
import { Navbar, Footer, FloatingWhatsApp, MobileBar, CookieBanner } from "./components/Layout";
import CleanHero from "./components/CleanHero";
import Catalog from "./components/Catalog";
import GeneralQuoteForm from "./components/GeneralQuoteForm";

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const openQuote = () => setQuoteOpen(true);
  useReveal();

  return (
    <div className="App">
      <Navbar onQuote={openQuote} />
      <CleanHero onQuote={openQuote} />
      <Catalog />
      <Footer />
      <FloatingWhatsApp />
      <MobileBar onQuote={openQuote} />
      <CookieBanner />
      <GeneralQuoteForm open={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}

export default App;
